import { UI, S, save } from '../../core/store.js';
import { off, readImg, uid } from '../../core/util.js';
import { render } from '../../core/shell.js';
import { toast } from '../../core/ui.js';
import { getP } from '../../core/selectors.js';
import { actions } from './actions.js';
import { curAsset, updPlayer } from './model.js';

// Click on the video timeline to jump to that moment.
export function timelineClick(e) {
  const tl = e.target.closest('#tl');
  if (!tl) return false;
  const r = tl.getBoundingClientRect();
  UI.pl.t = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * Number(tl.dataset.dur);
  updPlayer();
  return true;
}
// Arrow keys: scrub the timeline (when focused) or flip through photos in the lightbox.
export function reviewKey(e) {
  const arrow = e.key === 'ArrowRight' || e.key === 'ArrowLeft';
  const tl = e.target.closest && e.target.closest('#tl');
  if (tl && arrow) { UI.pl.t = Math.max(0, Math.min(Number(tl.dataset.dur), UI.pl.t + (e.key === 'ArrowRight' ? 5 : -5))); updPlayer(); return true; }
  if (UI.aid && arrow && !(e.target.closest && e.target.closest('input,textarea,select,[contenteditable]'))) {
    const a = curAsset();
    if (a && a.kind === 'photo') { actions.pnav({ dataset: { d: e.key === 'ArrowRight' ? 1 : -1 } }); return true; }
  }
  return false;
}
// Photos chosen with "Add photos" (UI.upMode === 'photos'). New photos start as drafts.
export function uploadPhotos(files) {
  const p = getP(UI.pid); let pending = files.length;
  files.forEach((f) => readImg(f, (url, w, h) => {
    if (url) S.assets.push({ id: uid(), pid: p.id, col: 'photo', title: f.name.replace(/\.[^.]+$/, ''), kind: 'photo', fmt: w >= h ? '3:2' : '2:3', dur: 0, ver: 1, status: 'In review', shared: false, fav: 0, comments: [], by: S.me, at: off(0), due: off(5), dl: true, img: url });
    if (--pending === 0) { save(); render(); toast('Photos added as drafts. Switch on Visible to client when ready.'); }
  }));
}
